window.SavoyQuizInit = function (CFG) {
  CFG = CFG || {};
  var root = document.getElementById(CFG.rootId || 'sq');
  if (!root) return;

  /* ---------- Perfiles olfativos (basados en los tags de Shopify) ---------- */
  var P = {
    poseidon: { name: 'Poseidon', insp: 'Acqua di Gio Profondo', g: 'h', tint: '#2F6E8C',
      fam: { mar: 3, hierbas: 2, citricos: 1 }, occ: { deporte: 3, diario: 3, oficina: 2 }, clima: 'calor', int: 2,
      mood: 'libre', line: 'Brisa marina y notas minerales. Frescura profunda que dura todo el día.' },
    helios: { name: 'Helios', insp: 'Naxos de Xerjoff', g: 'h', tint: '#B07A2A',
      fam: { dulce: 3, maderas: 2, especias: 2 }, occ: { noche: 3, cita: 2 }, clima: 'frio', int: 3,
      mood: 'magnetico', line: 'Miel dorada, especias cálidas y hojas aromáticas. Lujoso y envolvente.' },
    hades: { name: 'Hades', insp: 'Ombré Leather', g: 'h', tint: '#4A3328',
      fam: { cuero: 3, maderas: 2, especias: 1 }, occ: { noche: 3, cita: 2 }, clima: 'frio', int: 3,
      mood: 'magnetico', line: 'Cuero nuevo, intenso y ligeramente oscuro. Presencia que no pasa desapercibida.' },
    deimos: { name: 'Deimos', insp: 'Dior Sauvage', g: 'h', tint: '#3B4E6B',
      fam: { hierbas: 3, citricos: 2, especias: 2, maderas: 1 }, occ: { diario: 3, noche: 2, cita: 2, oficina: 1 }, clima: 'todo', int: 2.5,
      mood: 'elegante', line: 'Cítricos vibrantes y especias aromáticas. El versátil que funciona de día y de noche.' },
    atlas: { name: 'Atlas', insp: 'Aqva Marine', g: 'h', tint: '#3E8A8A',
      fam: { citricos: 3, mar: 3, hierbas: 2 }, occ: { diario: 3, oficina: 3, deporte: 2 }, clima: 'calor', int: 1,
      mood: 'libre', line: 'Olas sobre las rocas y aire salino. Limpio, revitalizante y fácil de llevar.' },
    afrodita: { name: 'Afrodita', insp: 'Pearl', g: 'm', tint: '#C9A3A8',
      fam: { flores: 3 }, occ: { diario: 3, oficina: 2 }, clima: 'todo', int: 1,
      mood: 'luminoso', line: 'Flores blancas y pétalos suaves al amanecer. Delicado y elegante.' },
    hecate: { name: 'Hecate', insp: 'Good Girl de Carolina Herrera', g: 'm', tint: '#3A2440',
      fam: { dulce: 3, flores: 2 }, occ: { noche: 3, cita: 3 }, clima: 'frio', int: 3,
      mood: 'magnetico', line: 'Flores intensas y dulzura envolvente. Una presencia imposible de olvidar.' },
    dione: { name: 'Dione', insp: 'Instant Crush', g: 'm', tint: '#9A5B3C',
      fam: { dulce: 3, flores: 2, especias: 1 }, occ: { noche: 3, cita: 2 }, clima: 'frio', int: 3,
      mood: 'magnetico', line: 'Ámbar cálido y flores sensuales. Sofisticado e intenso.' },
    atenea: { name: 'Atenea', insp: 'My Way de Giorgio Armani', g: 'm', tint: '#B9A58A',
      fam: { flores: 3, dulce: 1 }, occ: { oficina: 3, diario: 2 }, clima: 'todo', int: 2,
      mood: 'elegante', line: 'Flores blancas luminosas con feminidad moderna. Segura y sofisticada.' },
    theia: { name: 'Theia', insp: 'Erba Gold de Xerjoff', g: 'm', tint: '#C79A3B',
      fam: { frutas: 3, dulce: 2, flores: 1 }, occ: { diario: 3, cita: 1 }, clima: 'calor', int: 2,
      mood: 'luminoso', line: 'Frutas maduras bajo luz dorada. Alegre, lujosa y vibrante.' }
  };
  var PACKS = [
    { handle: 'hombre-fresco', name: 'Hombre Fresco', items: ['poseidon', 'deimos', 'atlas'] },
    { handle: 'hombre-intenso-hades-helios-deimos', name: 'Hombre Intenso', items: ['hades', 'helios', 'deimos'] },
    { handle: 'mujer-dione-hecate-theia', name: 'Mujer', items: ['dione', 'hecate', 'theia'] },
    { handle: 'el-ella-hecate-deimos-theia', name: 'Él & Ella', items: ['hecate', 'deimos', 'theia'] },
    { handle: 'mas-vendidos-poseidon-hecate-deimos', name: 'Más Vendidos', items: ['poseidon', 'hecate', 'deimos'] },
    { handle: 'noche-hades-helios-dione', name: 'Noche', items: ['hades', 'dione', 'helios'] },
    { handle: 'mujer-dia-afrodita-atenea-theia', name: 'Mujer Día', items: ['afrodita', 'atenea', 'theia'] }
  ];
  var BUILD_URL = CFG.buildUrl || '/products/arma-tu-tripack';
  var SHOP = CFG.shop || {};           // { handle: {url, img, price} } — viene de Shopify
  var BASE = CFG.baseUrl || '';
  var PRICE = CFG.priceDefault || '$36.990';
  var PACK_PRICE = CFG.packPriceDefault || '$9.990';

  /* ---------- Preguntas ---------- */
  var Q = [
    { id: 'g', t: '¿Qué estilo de fragancia buscas?', s: 'Puede ser para ti o para regalar.', opts: [
      ['h', 'Masculino'], ['m', 'Femenino'], ['x', 'Sorpréndeme', 'Te muestro lo mejor de ambas líneas']] },
    { id: 'occ', t: '¿Cuándo la usarías más?', opts: [
      ['diario', 'Día a día'], ['oficina', 'Oficina y reuniones'], ['noche', 'Noches y salidas'], ['cita', 'Una cita'], ['deporte', 'Deporte y aire libre']] },
    { id: 'fam', t: '¿Qué aromas te atraen?', s: 'Elige hasta dos.', multi: 2, opts: [
      ['mar', 'Mar y brisa'], ['citricos', 'Cítricos'], ['hierbas', 'Hierbas aromáticas'], ['maderas', 'Maderas'], ['cuero', 'Cuero'],
      ['dulce', 'Dulce', 'Vainilla, miel, ámbar'], ['flores', 'Flores'], ['frutas', 'Frutas'], ['especias', 'Especias']] },
    { id: 'clima', t: '¿En qué clima la vas a usar?', opts: [
      ['calor', 'Calor y verano'], ['frio', 'Frío e invierno'], ['todo', 'Todo el año']] },
    { id: 'piel', t: '¿Cómo es tu tipo de piel?', s: 'La piel influye en cuánto dura y cuánto proyecta un perfume.', opts: [
      ['seca', 'Seca', 'Se tira o pide crema seguido'], ['normal', 'Normal'], ['grasa', 'Grasa o mixta', 'Brilla durante el día'], ['nose', 'No estoy seguro']] },
    { id: 'ph', t: '¿Cómo reacciona tu piel a los perfumes?', s: 'La química de tu piel (su pH) cambia cómo se desarrolla un aroma.', opts: [
      ['corto', 'Me duran poco', 'Se esfuman en un par de horas'], ['dulce', 'Se vuelven más dulces o pesados'],
      ['igual', 'Huelen igual que en la tienda'], ['nose', 'Nunca me he fijado']] },
    { id: 'int', t: '¿Cuánto quieres que se note?', opts: [
      ['1', 'Cerca de la piel', 'Solo lo nota quien se acerca'], ['2', 'Equilibrado', 'Presente sin invadir'], ['3', 'Que deje huella', 'Estela que se recuerda']] },
    { id: 'mood', t: '¿Con qué frase te identificas?', opts: [
      ['libre', 'Tranquilo y libre'], ['elegante', 'Elegante y seguro'], ['magnetico', 'Magnético y misterioso'], ['luminoso', 'Luminoso y alegre']] }
  ];

  /* ---------- Premios ---------- */
  var PRIZES = CFG.prizes || [
    { id: 'p10', label: '10% OFF', long: '10% de descuento', code: 'BIENVENIDA10', w: 30 },
    { id: 'p15', label: '15% OFF', long: '15% de descuento', code: 'SAVOY15', w: 28 },
    { id: 'env', label: 'ENVÍO GRATIS', long: 'Envío gratis', code: 'ENVIOSAVOY', w: 20 },
    { id: 'tri', label: 'TRIPACK', long: 'Tripack de regalo', code: 'SAVOYTRIPACK', w: 12 },
    { id: 'p25', label: '25% OFF', long: '25% de descuento', code: 'SAVOY25', w: 6 }
  ];
  var SEG = ['p10', 'tri', 'p15', 'env', 'p25', 'p10', 'tri', 'p15'];
  var STORE_KEY = 'savoy-ruleta-v1';

  /* ---------- Estado ---------- */
  var st = { i: 0, a: {} };
  var $ = function (s) { return root.querySelector(s); };
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function saved() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } }
  function save(v) { try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) {} }

  /* ---------- Puntaje ---------- */
  function score(a) {
    var out = [];
    Object.keys(P).forEach(function (k) {
      var p = P[k], s = 0, max = 0;
      if (a.g && a.g !== 'x' && p.g !== a.g) return;
      (a.fam || []).forEach(function (f) { s += (p.fam[f] || 0) * 4; max += 12; });
      if (a.occ) { s += (p.occ[a.occ] || 0) * 3; max += 9; }
      if (a.clima) { max += 6; s += p.clima === a.clima ? 6 : (p.clima === 'todo' || a.clima === 'todo') ? 4 : 0; }
      var want = +a.int || 2;
      // Piel seca y perfumes que se esfuman: conviene más concentración y fondos cálidos
      var longevity = 0;
      if (a.piel === 'seca') longevity += 1;
      if (a.ph === 'corto') longevity += 1;
      if (longevity) { want = Math.min(3, want + 0.5 * longevity); s += ((p.fam.maderas || 0) + (p.fam.dulce || 0) + (p.fam.cuero || 0)) * longevity * 0.6; max += 4 * longevity; }
      // Piel grasa o que "endulza": mejor frescos y cítricos, cuidado con los muy dulces
      var heat = (a.piel === 'grasa' ? 1 : 0) + (a.ph === 'dulce' ? 1 : 0);
      if (heat) { s += ((p.fam.citricos || 0) + (p.fam.mar || 0) + (p.fam.hierbas || 0)) * heat * 0.6 - (p.fam.dulce || 0) * heat * 0.5; max += 4 * heat; want = Math.max(1, want - 0.3 * heat); }
      max += 6; s += Math.max(0, 6 - Math.abs(p.int - want) * 3);
      if (a.mood) { max += 5; if (p.mood === a.mood) s += 5; }
      out.push({ k: k, s: s, pct: Math.round(Math.max(0, Math.min(1, s / max)) * 30 + 68) });
    });
    out.sort(function (x, y) { return y.s - x.s; });
    // porcentaje del primero siempre > segundo > tercero
    for (var i = 1; i < out.length; i++) if (out[i].pct >= out[i - 1].pct) out[i].pct = out[i - 1].pct - 2;
    return out;
  }
  function bestPack(top) {
    var ks = top.slice(0, 3).map(function (r) { return r.k; });
    var best = null, bs = -1;
    PACKS.forEach(function (pk) {
      if (pk.items.indexOf(ks[0]) < 0) return;
      var s = pk.items.filter(function (x) { return ks.indexOf(x) >= 0; }).length;
      if (s > bs) { bs = s; best = pk; }
    });
    return best;
  }
  function tips(a) {
    var t = [];
    if (a.piel === 'seca' || a.ph === 'corto') t.push('Aplica una crema sin aroma antes del perfume: la piel hidratada retiene la fragancia por más horas.');
    if (a.piel === 'grasa' || a.ph === 'dulce') t.push('Tu piel proyecta bien. Con 2 a 3 disparos basta; los aromas frescos se mantienen más limpios en ti.');
    t.push('Rocía en puntos de pulso (cuello, muñecas, detrás de las orejas) y no frotes: frotar rompe las notas de salida.');
    return t;
  }

  /* ---------- Vistas ---------- */
  function bottle(k, big) {
    var p = P[k], sh = SHOP[k] || {}, src = (CFG.imgs && CFG.imgs[k]) || sh.img;
    var fb = sh.img && sh.img !== src ? ' onerror="this.onerror=null;this.src=\'' + esc(sh.img) + '\'"' : '';
    if (src) return '<img class="sq-img' + (big ? ' sq-img--big' : '') + '" src="' + esc(src) + '" alt="Frasco ' + esc(p.name) + ' Savoy 50 ml" decoding="async"' + fb + '>';
    return '<div class="sq-bottle' + (big ? ' sq-bottle--big' : '') + '" style="--tint:' + p.tint + '" aria-hidden="true"><span class="sq-cap"></span><span class="sq-glass"><span>' + esc(p.name.charAt(0)) + '</span></span></div>';
  }
  function logo() { return CFG.logo ? '<img class="sq-logo" src="' + esc(CFG.logo) + '" alt="Savoy Parfum" onerror="this.remove()">' : ''; }
  function url(h) { return (SHOP[h] && SHOP[h].url) || (BASE + '/products/' + h); }

  function renderIntro() {
    root.innerHTML =
      '<section class="sq-card sq-intro">' + logo() +
      '<h2 class="sq-h1">Descubre tu fragancia</h2>' +
      '<p class="sq-lead">Ocho preguntas sobre tu piel, tus momentos y los aromas que te atraen. Al final te decimos cuál de nuestras fragancias es para ti y giras la ruleta por un premio.</p>' +
      '<button class="sq-btn" id="sq-start" type="button">Comenzar</button>' +
      '<p class="sq-fine">Toma menos de un minuto.</p>' +
      '</section>';
    $('#sq-start').onclick = function () { st.i = 0; renderQ(); };
  }

  function renderQ() {
    var q = Q[st.i], cur = st.a[q.id];
    var sel = function (v) { return q.multi ? (cur || []).indexOf(v) >= 0 : cur === v; };
    root.innerHTML =
      '<section class="sq-card">' +
      '<div class="sq-progress"><span>' + (st.i + 1) + ' / ' + Q.length + '</span><div class="sq-bar"><i style="width:' + ((st.i + 1) / Q.length * 100) + '%"></i></div></div>' +
      '<h2 class="sq-h2">' + esc(q.t) + '</h2>' + (q.s ? '<p class="sq-sub">' + esc(q.s) + '</p>' : '') +
      '<div class="sq-opts' + (q.opts.length > 5 ? ' sq-opts--grid' : '') + '" role="' + (q.multi ? 'group' : 'radiogroup') + '">' +
      q.opts.map(function (o) {
        return '<button type="button" class="sq-opt" data-v="' + o[0] + '" aria-pressed="' + sel(o[0]) + '"><b>' + esc(o[1]) + '</b>' + (o[2] ? '<small>' + esc(o[2]) + '</small>' : '') + '</button>';
      }).join('') + '</div>' +
      '<div class="sq-nav"><button type="button" class="sq-link" id="sq-back">' + (st.i ? '← Atrás' : '← Inicio') + '</button>' +
      (q.multi ? '<button type="button" class="sq-btn sq-btn--sm" id="sq-next"' + ((cur || []).length ? '' : ' disabled') + '>Siguiente</button>' : '') + '</div>' +
      '</section>';
    root.querySelectorAll('.sq-opt').forEach(function (b) {
      b.onclick = function () {
        var v = b.dataset.v;
        if (q.multi) {
          var arr = (st.a[q.id] || []).slice(), ix = arr.indexOf(v);
          if (ix >= 0) arr.splice(ix, 1); else { arr.push(v); if (arr.length > q.multi) arr.shift(); }
          st.a[q.id] = arr; renderQ();
        } else { st.a[q.id] = v; b.setAttribute('aria-pressed', 'true'); setTimeout(next, 180); }
      };
    });
    $('#sq-back').onclick = function () { if (st.i) { st.i--; renderQ(); } else renderIntro(); };
    var n = $('#sq-next'); if (n) n.onclick = next;
    var first = root.querySelector('.sq-opt'); if (first && st.i) first.focus({ preventScroll: true });
  }
  function next() { if (st.i < Q.length - 1) { st.i++; renderQ(); } else renderResult(); }

  function renderResult() {
    var r = score(st.a); st.res = r;
    var top = r[0], p = P[top.k], pack = bestPack(r);
    var sh = SHOP[top.k] || {};
    root.innerHTML =
      '<section class="sq-card sq-result">' +
      '<p class="sq-eyebrow">Tu fragancia Savoy</p>' +
      '<div class="sq-hero">' + bottle(top.k, true) +
      '<div class="sq-hero-txt"><p class="sq-match">' + top.pct + '% afinidad</p><h2 class="sq-h1">' + esc(p.name) + '</h2>' +
      '<p class="sq-insp">Inspirado en ' + esc(p.insp) + ' · 50 ml</p><p class="sq-lead">' + esc(p.line) + '</p>' +
      '<div class="sq-row"><a class="sq-btn" href="' + url(top.k) + '">Ver ' + esc(p.name) + ' · ' + esc(sh.price || PRICE) + '</a></div></div></div>' +
      '<h3 class="sq-h3">También van contigo</h3><div class="sq-alts">' +
      r.slice(1, 3).map(function (x) { var q = P[x.k]; return '<a class="sq-alt" href="' + url(x.k) + '">' + bottle(x.k) + '<span><b>' + esc(q.name) + '</b><small>' + x.pct + '% · ' + esc(q.insp) + '</small></span></a>'; }).join('') +
      '</div>' +
      (pack ? '<div class="sq-pack"><div><p class="sq-eyebrow">¿Prefieres probar antes?</p><p><b>Set ' + esc(pack.name) + '</b> — 3 decants: ' + pack.items.map(function (k) { return esc(P[k].name); }).join(', ') + '</p></div><a class="sq-btn sq-btn--ghost" href="' + url(pack.handle) + '">Ver set · ' + esc((SHOP[pack.handle] || {}).price || PACK_PRICE) + '</a></div>' : '') +
      '<p class="sq-fine" style="text-align:center"><a class="sq-link" href="' + esc(BUILD_URL) + '">¿Prefieres elegir tú? Arma tu tripack con cualquiera de nuestras 10 fragancias →</a></p>' +
      '<ul class="sq-tips">' + tips(st.a).map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>' +
      (CFG.wheel === false ? '' : '<div class="sq-cta"><div><h3 class="sq-h3">Gira la ruleta Savoy</h3><p class="sq-sub">Deja tu correo y gana un premio para tu primera compra.</p></div><button class="sq-btn" id="sq-towheel" type="button">Quiero mi premio</button></div>') +
      '<button type="button" class="sq-link" id="sq-redo">Repetir el test</button>' +
      '</section>';
    $('#sq-redo').onclick = function () { st = { i: 0, a: {} }; renderQ(); };
    var tw = $('#sq-towheel'); if (tw) tw.onclick = renderWheel;
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---------- Ruleta ---------- */
  function prize(id) { if (id === 'd2' || id === 'd3') id = 'tri'; return PRIZES.filter(function (p) { return p.id === id; })[0]; }
  function wheelSVG() {
    var n = SEG.length, R = 150, c = 160, out = '';
    for (var i = 0; i < n; i++) {
      var a0 = (i / n) * 2 * Math.PI - Math.PI / 2, a1 = ((i + 1) / n) * 2 * Math.PI - Math.PI / 2;
      var x0 = c + R * Math.cos(a0), y0 = c + R * Math.sin(a0), x1 = c + R * Math.cos(a1), y1 = c + R * Math.sin(a1);
      out += '<path d="M' + c + ',' + c + ' L' + x0.toFixed(2) + ',' + y0.toFixed(2) + ' A' + R + ',' + R + ' 0 0,1 ' + x1.toFixed(2) + ',' + y1.toFixed(2) + ' Z" class="' + (i % 2 ? 'sq-s1' : 'sq-s2') + '"/>';
      var am = ((i + 0.5) / n) * 360;
      out += '<g transform="rotate(' + am + ' ' + c + ' ' + c + ')"><text x="' + c + '" y="' + (c - 90) + '" dy="4" transform="rotate(-90 ' + c + ' ' + (c - 90) + ')" class="' + (i % 2 ? 'sq-t1' : 'sq-t2') + '" text-anchor="middle">' + esc((prize(SEG[i]) || PRIZES[0]).label) + '</text></g>';
    }
    return '<svg viewBox="0 0 320 320" class="sq-wheel" id="sq-wheel" role="img" aria-label="Ruleta de premios"><circle cx="160" cy="160" r="156" class="sq-rim"/>' + out +
      '<circle cx="160" cy="160" r="30" class="sq-hub"/><text x="160" y="165" text-anchor="middle" class="sq-hubt">S</text></svg>';
  }
  function renderWheel() {
    var prev = saved();
    if (prev) return renderWin(prize(prev.id) || PRIZES[0], true);
    root.innerHTML =
      '<section class="sq-card sq-wheelwrap">' +
      (CFG.mode === 'popup' ? logo() : '') + '<p class="sq-eyebrow">Ruleta Savoy</p><h2 class="sq-h2">' + (CFG.mode === 'popup' ? 'Gira y gana un premio para tu primera compra' : 'Un giro, un premio seguro') + '</h2>' +
      '<div class="sq-wheelbox"><span class="sq-pin" aria-hidden="true"></span>' + wheelSVG() + '</div>' +
      '<form class="sq-form" id="sq-form" novalidate>' +
      '<div class="sq-fields"><label>Nombre<input id="sq-name" name="name" autocomplete="given-name" required></label>' +
      '<label>Correo<input id="sq-email" name="email" type="email" autocomplete="email" required></label>' +
      '<label>WhatsApp <em>(opcional)</em><input id="sq-wa" name="wa" type="tel" inputmode="tel" autocomplete="tel" placeholder="+56 9 1234 5678"></label></div>' +
      '<label class="sq-check"><input type="checkbox" id="sq-ok" required> Acepto recibir novedades y ofertas de Savoy. Puedo darme de baja cuando quiera.</label>' +
      '<p class="sq-err" id="sq-err" hidden></p>' +
      '<button class="sq-btn" type="submit" id="sq-spin">Girar la ruleta</button>' +
      '<p class="sq-fine">Un giro por persona. Premio válido para una compra en savoy.cl.</p>' +
      '</form></section>';
    $('#sq-form').onsubmit = function (e) {
      e.preventDefault();
      var name = $('#sq-name').value.trim(), email = $('#sq-email').value.trim(), wa = $('#sq-wa').value.replace(/[^\d+]/g, ''), err = $('#sq-err');
      var msg = !name ? 'Escribe tu nombre.' : !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email) ? 'Revisa tu correo, parece incompleto.' :
        (wa && wa.replace(/\D/g, '').length < 8) ? 'El WhatsApp debe tener al menos 8 dígitos, o déjalo vacío.' : !$('#sq-ok').checked ? 'Marca la casilla para recibir tu premio por correo.' : '';
      if (msg) { err.textContent = msg; err.hidden = false; return; }
      err.hidden = true; spin({ name: name, email: email, wa: wa });
    };
  }
  function pick() {
    var tot = PRIZES.reduce(function (s, p) { return s + (+p.w || 0); }, 0), r = Math.random() * tot;
    for (var i = 0; i < PRIZES.length; i++) { r -= +PRIZES[i].w || 0; if (r < 0) return PRIZES[i]; }
    return PRIZES[0];
  }
  function spin(contact) {
    var btn = $('#sq-spin'); btn.disabled = true; btn.textContent = 'Girando…';
    root.querySelectorAll('.sq-form input').forEach(function (i) { i.disabled = true; });
    var pz = pick(), idx = [];
    SEG.forEach(function (s, i) { if (s === pz.id) idx.push(i); });
    var seg = idx.length ? idx[Math.floor(Math.random() * idx.length)] : 0, n = SEG.length;
    var jitter = (Math.random() - 0.5) * (360 / n) * 0.6;
    var deg = 360 * 6 + (360 - (seg + 0.5) * (360 / n)) + jitter;
    var w = $('#sq-wheel'), reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    w.style.transition = reduce ? 'none' : 'transform 5.2s cubic-bezier(.12,.72,.12,1)';
    requestAnimationFrame(function () { w.style.transform = 'rotate(' + deg + 'deg)'; });
    var top = st.res ? st.res[0].k : '';
    save({ id: pz.id, t: Date.now() });
    if (typeof CFG.onLead === 'function') { try { CFG.onLead(contact, pz, top); } catch (e) {} }
    setTimeout(function () { renderWin(pz, false); }, reduce ? 300 : 5600);
  }
  function renderWin(pz, again) {
    var top = st.res ? st.res[0].k : null;
    var isTri = pz.id === 'tri';
    var redirect = isTri ? BUILD_URL : top ? '/products/' + top : '/collections/all';
    var apply = BASE + '/discount/' + encodeURIComponent(pz.code) + '?redirect=' + encodeURIComponent(redirect);
    root.innerHTML =
      '<section class="sq-card sq-win">' +
      '<p class="sq-eyebrow">' + (again ? 'Ya giraste la ruleta' : 'Ganaste') + '</p>' +
      '<h2 class="sq-h1 sq-bigprize">' + esc(pz.long) + '</h2>' +
      (isTri
        ? '<p class="sq-sub">Elige los 3 decants que quieras probar, de hombre o de mujer. El tripack es gratis: solo pagas el envío.</p>'
        : '<p class="sq-sub">Guarda este código: lo ingresas al pagar.</p>') +
      '<div class="sq-code"><code id="sq-code">' + esc(pz.code) + '</code><button type="button" class="sq-btn sq-btn--sm sq-btn--ghost" id="sq-copy">Copiar</button></div>' +
      '<a class="sq-btn" href="' + apply + '">' + (isTri ? 'Armar mi tripack gratis' : 'Aplicar y comprar' + (top ? ' ' + esc(P[top].name) : '')) + '</a>' +
      (again ? '' : '<p class="sq-fine">Este botón aplica el código automáticamente en el carrito.</p>') +
      (st.res ? '<button type="button" class="sq-link" id="sq-backres">← Volver a mi resultado</button>' : '') +
      (!st.res && CFG.quizUrl ? '<a class="sq-link" href="' + esc(CFG.quizUrl) + '">¿No sabes cuál elegir? Descubre tu fragancia →</a>' : '') +
      '</section>';
    $('#sq-copy').onclick = function () {
      var b = this;
      (navigator.clipboard ? navigator.clipboard.writeText(pz.code) : Promise.reject()).then(function () { b.textContent = 'Copiado'; })
        .catch(function () { var r = document.createRange(); r.selectNodeContents($('#sq-code')); var s = getSelection(); s.removeAllRanges(); s.addRange(r); b.textContent = 'Selecciónalo'; });
    };
    var br = $('#sq-backres'); if (br) br.onclick = renderResult;
  }

  if (CFG.mode === 'popup') renderWheel(); else renderIntro();
  return { wheel: renderWheel };
};

window.SavoyWheelPopup = function (o) {
  o = o || {};
  var SPUN = 'savoy-ruleta-v1', SEEN = 'savoy_ruleta_cerrada';
  var scrollAt = o.scroll == null ? 0.4 : o.scroll, delay = +o.delay || 0, days = o.days == null ? 3 : o.days;
  function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function getC(n) { try { var p = ('; ' + document.cookie).split('; ' + n + '='); return p.length === 2 ? p.pop().split(';').shift() : null; } catch (e) { return null; } }
  function setC(n, v, d) { try { var e = new Date(); e.setTime(e.getTime() + d * 864e5); document.cookie = n + '=' + v + ';expires=' + e.toUTCString() + ';path=/'; } catch (x) {} }

  var pop = document.createElement('div');
  pop.className = 'sq-pop'; pop.hidden = true;
  pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-modal', 'true'); pop.setAttribute('aria-label', 'Ruleta de premios Savoy');
  pop.innerHTML = '<div class="sq" style="position:relative"><button type="button" class="sq-close" aria-label="Cerrar">&times;</button><div id="sq-pop-root"></div></div>';
  var tab = document.createElement('button');
  tab.type = 'button'; tab.className = 'sq-tab'; tab.hidden = true;
  tab.innerHTML = '<i aria-hidden="true"></i><span>' + (ls(SPUN) ? 'Mi premio' : 'Gira y gana') + '</span>';
  document.body.appendChild(pop); document.body.appendChild(tab);

  var started = false, opened = false;
  function open() {
    if (opened) return; opened = true;
    if (!started) {
      started = true;
      var cfg = {}; for (var k in (o.cfg || {})) cfg[k] = o.cfg[k];
      cfg.rootId = 'sq-pop-root'; cfg.mode = 'popup';
      window.SavoyQuizInit(cfg);
    }
    pop.hidden = false; tab.hidden = true;
    document.documentElement.style.overflow = 'hidden';
    pop.querySelector('.sq-close').focus({ preventScroll: true });
  }
  function close() {
    pop.hidden = true; opened = false;
    document.documentElement.style.overflow = '';
    setC(SEEN, '1', days);
    if (o.tab !== false) { tab.querySelector('span').textContent = ls(SPUN) ? 'Mi premio' : 'Gira y gana'; tab.hidden = false; }
  }
  pop.querySelector('.sq-close').onclick = close;
  pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened) close(); });
  tab.onclick = open;

  // Ya giró o ya cerró hace poco: solo mostramos la pestaña flotante
  if (ls(SPUN) || getC(SEEN)) { if (o.tab !== false) tab.hidden = false; return { open: open }; }

  var auto = false;
  function trigger() { if (auto || (o.skip && o.skip())) return; auto = true; window.removeEventListener('scroll', onScroll); open(); }
  function onScroll() {
    if (o.after) { var el = document.querySelector(o.after); if (el && el.getBoundingClientRect().top < innerHeight * 0.15) trigger(); return; }
    var h = document.documentElement, max = h.scrollHeight - h.clientHeight;
    if (max > 0 && h.scrollTop / max >= scrollAt) trigger();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  if (delay > 0) setTimeout(trigger, delay * 1000);
  return { open: open };
};
